export default __webpack_public_path__ + "static/media/cardinal-full-white.aaa28a03.svg";